export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";